import { MenuProps } from "@mui/material";
import { isEmpty } from "lodash";
import ButtonMenu, { TButtonMenuBaseProps, TMenuOption } from "../ButtonMenu";
import MenuItem from "./MenuItem";
import styles from "./MenuItem.styles";

export type TRenderOptionProps = Omit<
  MenuProps,
  "MenuListProps" | "onSelect" | "open" | "options"
> &
  Omit<TButtonMenuBaseProps, "options"> & {
    option: TMenuOption;
    onClose: () => void;
    isShowInset: boolean;
    shouldBeSeparated: boolean;
  };

const Option = ({
  dense,
  onSelect,
  value,
  option,
  onClose,
  isShowInset,
  shouldBeSeparated,
  ...props
}: TRenderOptionProps) => {
  const menuItemStyles = shouldBeSeparated
    ? styles.menuItemWithSeparator
    : styles.menuItem;

  return !isEmpty(option.items) ? (
    <ButtonMenu
      {...props}
      key={option.id}
      dense={dense}
      options={option.items ?? []}
      sx={styles.menu}
      value={value}
      onSelect={option.onClick || onSelect}
      onClose={onClose}
    >
      <MenuItem
        key={`menu-item-${option.id}`}
        dense={dense}
        sx={menuItemStyles}
        option={option}
        disabled={option.disabled}
      />
    </ButtonMenu>
  ) : (
    <MenuItem
      key={`menu-item-${option.id}`}
      dense={dense}
      onClick={() => {
        onSelect?.(option);
        option.onClick?.();
        onClose?.();
      }}
      sx={menuItemStyles}
      option={option}
      isSelected={isShowInset && value ? option.id === value : undefined}
      adornment={option.adornment}
      disabled={option.disabled}
    />
  );
};

export default Option;
